import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web--source/common/localization/getCountryDisplayNameFromSessionCountry";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { isLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
export var getMetaTitle = function(param, strictLocalize) {
    var productName = param.productName, isFaireDirectActiveInLoggedOut = param.isFaireDirectActiveInLoggedOut, showForLoggedInRetailerOrBrandPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!productName) {
        return null;
    }
    var countryDisplayName = getCountryDisplayNameFromSessionCountry(getSessionCountry(), strictLocalize);
    var shouldShowMetaTitle = shouldShowSEOMetaText({
        showForLoggedInRetailerOrBrandPreview: showForLoggedInRetailerOrBrandPreview,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    });
    if (shouldShowMetaTitle) {
        if (shouldNotPrependWholesaleWord(productName)) {
            return countryDisplayName ? strictLocalize({
                id: "759sB0",
                defaultMessage: [
                    {
                        type: 1,
                        value: "ProductName"
                    },
                    {
                        type: 0,
                        value: " for your store - Faire "
                    },
                    {
                        type: 1,
                        value: "country"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                ProductName: productName,
                country: countryDisplayName
            })) : strictLocalize({
                id: "1Zx2lS",
                defaultMessage: [
                    {
                        type: 1,
                        value: "ProductName"
                    },
                    {
                        type: 0,
                        value: " for your store - Faire"
                    }
                ]
            }, {
                ProductName: productName
            });
        }
        return countryDisplayName ? strictLocalize({
            id: "qBAS4U",
            defaultMessage: [
                {
                    type: 0,
                    value: "Wholesale "
                },
                {
                    type: 1,
                    value: "ProductName"
                },
                {
                    type: 0,
                    value: " for your store - Faire "
                },
                {
                    type: 1,
                    value: "country"
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            ProductName: productName,
            country: countryDisplayName
        })) : strictLocalize({
            id: "tGNeC+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Wholesale "
                },
                {
                    type: 1,
                    value: "ProductName"
                },
                {
                    type: 0,
                    value: " for your store - Faire"
                }
            ]
        }, {
            ProductName: productName
        });
    }
    return "".concat(productName, " - Faire");
};
export var getMetaDescription = function(param, strictLocalize) {
    var productName = param.productName, brandCompanyName = param.brandCompanyName, productDescription = param.productDescription, isFaireDirectActiveInLoggedOut = param.isFaireDirectActiveInLoggedOut;
    if (!productName || !brandCompanyName || !productDescription) {
        return null;
    }
    var shouldShowMetaDescription = shouldShowSEOMetaText({
        showForLoggedInRetailerOrBrandPreview: true,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    });
    if (shouldShowMetaDescription) {
        if (shouldNotPrependWholesaleWord(productName)) {
            return strictLocalize({
                id: "NQwNiv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Shop "
                    },
                    {
                        type: 1,
                        value: "ProductName"
                    },
                    {
                        type: 0,
                        value: " from "
                    },
                    {
                        type: 1,
                        value: "brandCompanyName"
                    },
                    {
                        type: 0,
                        value: " and more for your store on Faire. Stock up on unique brands and products, with free returns and low order minimums."
                    }
                ]
            }, {
                ProductName: productName,
                brandCompanyName: brandCompanyName
            });
        }
        return strictLocalize({
            id: "jWqaL1",
            defaultMessage: [
                {
                    type: 0,
                    value: "Shop wholesale "
                },
                {
                    type: 1,
                    value: "ProductName"
                },
                {
                    type: 0,
                    value: " from "
                },
                {
                    type: 1,
                    value: "brandCompanyName"
                },
                {
                    type: 0,
                    value: " and more for your store on Faire. Stock up on unique brands and products, with free returns and low order minimums."
                }
            ]
        }, {
            ProductName: productName,
            brandCompanyName: brandCompanyName
        });
    }
    return strictLocalize({
        id: "ygevfB",
        defaultMessage: [
            {
                type: 0,
                value: "Buy wholesale with free returns. "
            },
            {
                type: 1,
                value: "description"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        description: productDescription
    }));
};
export var getProductHeaderName = function(param, strictLocalize) {
    var productName = param.productName, isFaireDirectActiveInLoggedOut = param.isFaireDirectActiveInLoggedOut;
    if (!productName) {
        return null;
    }
    var shouldShowHeader = shouldShowSEOMetaText({
        hideForFaireDirect: true,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    });
    if (!shouldShowHeader || shouldNotPrependWholesaleWord(productName)) {
        return productName;
    }
    if (shouldUpperWholesaleWord(productName)) {
        return strictLocalize({
            id: "CL6e+W",
            defaultMessage: [
                {
                    type: 0,
                    value: "WHOLESALE "
                },
                {
                    type: 1,
                    value: "ProductName"
                }
            ]
        }, {
            ProductName: productName
        });
    }
    return strictLocalize({
        id: "n+alvb",
        defaultMessage: [
            {
                type: 0,
                value: "Wholesale "
            },
            {
                type: 1,
                value: "ProductName"
            }
        ]
    }, {
        ProductName: productName
    });
};
export var getProductSubheaderName = function(param, strictLocalize) {
    var brandCompanyName = param.brandCompanyName, isFaireDirectActiveInLoggedOut = param.isFaireDirectActiveInLoggedOut;
    var shouldShowSubheader = shouldShowSEOMetaText({
        hideForFaireDirect: true,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    });
    if (!brandCompanyName || !shouldShowSubheader) {
        return null;
    }
    return strictLocalize({
        id: "h48OhH",
        defaultMessage: [
            {
                type: 0,
                value: "With Faire, shop unique wholesale products for your store from brands like "
            },
            {
                type: 1,
                value: "brandCompanyName"
            },
            {
                type: 0,
                value: " and more."
            }
        ]
    }, {
        brandCompanyName: brandCompanyName
    });
};
var shouldShowSEOMetaText = function(options) {
    var _options_hideForFaireDirect;
    var hideForFaireDirect = (_options_hideForFaireDirect = options.hideForFaireDirect) !== null && _options_hideForFaireDirect !== void 0 ? _options_hideForFaireDirect : false;
    var _options_showForLoggedInRetailerOrBrandPreview;
    var showForLoggedInRetailerOrBrandPreview = (_options_showForLoggedInRetailerOrBrandPreview = options.showForLoggedInRetailerOrBrandPreview) !== null && _options_showForLoggedInRetailerOrBrandPreview !== void 0 ? _options_showForLoggedInRetailerOrBrandPreview : false;
    return (showForLoggedInRetailerOrBrandPreview || !isLoggedInRetailerOrBrandPreview()) && !(hideForFaireDirect && (options === null || options === void 0 ? void 0 : options.isFaireDirectActiveInLoggedOut));
};
var wholesaleKeywordsMap = new Map([
    [
        Language.ENG,
        /\b(wholesale|whole sale|whole-sale|wholesal|bulk)\b/gi
    ],
    [
        Language.FRA,
        /\b(en gros|en vente B2B|de gros|en vrac)\b/gi
    ],
    [
        Language.ITA,
        /\b(in vendita B2B|in stock|in blocco|all’ingrosso|all'ingrosso)\b/gi
    ],
    [
        Language.SPA,
        /\b(al por mayor|mayorista|en masa|a granel|en lote|por lotes)\b/gi
    ],
    // We don't want word boundaries in DEU because they form compound words (ie. Großhandelssocken).
    [
        Language.DEU,
        /(Massen|Sammel|Großhandel|Mengen|Grosshandel)/gi
    ]
]);
var shouldNotPrependWholesaleWord = function(name) {
    var _getLocaleKey;
    var _getLocaleKey_language;
    var language = (_getLocaleKey_language = (_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language) !== null && _getLocaleKey_language !== void 0 ? _getLocaleKey_language : Language.ENG;
    if (!wholesaleKeywordsMap.has(language)) {
        return true;
    } else {
        return name.search(wholesaleKeywordsMap.get(language)) !== -1;
    }
};
// We want to check if the number of capital letters in a string (compared to all letters
// in the string) exceeds a threshold to decide whether we should upper case "wholesale".
var shouldUpperWholesaleWord = function(name) {
    var THRESHOLD_FOR_UPPER_CASE = 0.7;
    var numberOfUpperCaseCharactersInName = 0;
    var numberOfNaNInName = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = name[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            if (isNaN(Number(char))) {
                numberOfNaNInName++;
                if (char === char.toUpperCase()) {
                    numberOfUpperCaseCharactersInName++;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return numberOfUpperCaseCharactersInName / numberOfNaNInName > THRESHOLD_FOR_UPPER_CASE;
};
